<template>
	<div class="content-wrapper">
		<div class="content-header">
			<Skeleton width="10rem" height="1.25rem" />
		</div>
		<div class="content-body">
			<div class="snap-card-skeleton">
				<Skeleton shape="circle" size="4rem" class="snap-icon-skeleton" />
				<div class="snap-content-skeleton">
					<Skeleton width="55%" height="1.25rem" class="mb-3" />
					<Skeleton width="100%" height="0.875rem" class="mb-2" />
					<Skeleton width="92%" height="0.875rem" class="mb-2" />
					<Skeleton width="35%" height="0.75rem" />
				</div>
				<Skeleton width="9.5rem" height="2.75rem" borderRadius="6px" class="snap-btn-skeleton" />
			</div>
		</div>
	</div>
</template>

<style scoped>
.snap-card-skeleton {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
	padding: 32px 24px;
	background: #f8f9fb;
	border: 1px solid #e0e4ea;
	border-radius: 12px;
}

@media (min-width: 768px) {
	.snap-card-skeleton {
		flex-direction: row;
		align-items: center;
		padding: 28px 32px;
	}
}

.snap-content-skeleton {
	flex: 1;
	width: 100%;
}

.snap-icon-skeleton {
	flex-shrink: 0;
}

.snap-btn-skeleton {
	flex-shrink: 0;
}
</style>
